import axios from 'axios';
import config from '../../../../../core/config/configureSettings';
import { constructServiceURL } from '../../../../../core/modules/common/tools/URLTools';

const apiFetchCarrierCarditResditBestPracticeElements = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getCarrierCarditResditBestPracticeElements',
    stub: config.useStubbedEndpoints,
  });
  return axios.post(serviceURL, payload, {
    cancelToken: payload.token,
  });
};

export default apiFetchCarrierCarditResditBestPracticeElements;
